import React from 'react';
import { Link } from 'react-router-dom';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useScript();
  useDocumentTitle(t('Политика приватности') + ' — ' + t('Манастир Градац'), '/politika-privatnosti');

  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back-link">{t('← Назад')}</Link>
        <h1 className="legal-page-title">{t('Политика приватности')}</h1>
        <p className="legal-page-updated">{t('Последње ажурирање')}: 07. јул 2026.</p>

        <section className="legal-section">
          <h2>{t('Увод')}</h2>
          <p>
            {t('Манастир Градац (у даљем тексту: „ми", „нас" или „наш") поштује приватност посетилаца овог веб-сајта. Ова Политика приватности објашњава које податке прикупљамо, зашто их прикупљамо и како их користимо, у складу са Законом о заштити података о личности Републике Србије („Сл. гласник РС", бр. 87/2018).')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Руковалац подацима')}</h2>
          <p>
            {t('Руковалац подацима о личности је Манастир Градац, 36346 Брвеник, Рашка, Република Србија.')}
          </p>
          <p>{t('Контакт')}: manastir.gradac@gmail.com</p>
        </section>

        <section className="legal-section">
          <h2>{t('Подаци које прикупљамо')}</h2>
          <ul>
            <li>{t('Контакт подаци (име, имејл, телефон) — само када нам их добровољно доставите путем формулара за наруџбине или контакта.')}</li>
            <li>{t('Подаци о посетама — аутоматски прикупљени подаци попут IP адресе, типа претраживача, времена посете и посећених страница (путем колачића и сличних технологија).')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('Сврха обраде')}</h2>
          <ul>
            <li>{t('Обрада наруџбина и одговарање на упите посетилаца.')}</li>
            <li>{t('Побољшање садржаја и функционалности веб-сајта.')}</li>
            <li>{t('Статистичка анализа посећености.')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('Правни основ')}</h2>
          <p>
            {t('Обрада података се врши на основу Вашег пристанка (члан 12. став 1. тачка 1. Закона) и легитимног интереса руковаоца (члан 12. став 1. тачка 6. Закона).')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Права лица на које се подаци односе')}</h2>
          <p>{t('У складу са Законом, имате право на:')}</p>
          <ul>
            <li>{t('Приступ Вашим личним подацима')}</li>
            <li>{t('Исправку нетачних података')}</li>
            <li>{t('Брисање података („право на заборав")')}</li>
            <li>{t('Ограничење обраде')}</li>
            <li>{t('Преносивост података')}</li>
            <li>{t('Приговор на обраду')}</li>
          </ul>
          <p>
            {t('За остваривање ових права, контактирајте нас на manastir.gradac@gmail.com.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Чување података')}</h2>
          <p>
            {t('Ваше личне податке чувамо само онолико колико је потребно за испуњење сврхе за коју су прикупљени, или у складу са законским обавезама.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Повереник за информације')}</h2>
          <p>
            {t('Уколико сматрате да је обрада Ваших података извршена супротно Закону, имате право на подношење притужбе Поверенику за информације од јавног значаја и заштиту података о личности Републике Србије.')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
